import * as React from 'react';
import useModal from 'hooks/use-modal';
import Button, {ButtonVariant} from 'components/Button';
import InviteModal from './components/InviteModal';

export interface InviteButtonProps {
  onInvite?(): void;
}

/**
 *
 * @param {InviteButtonProps} props
 * @return {React.ReactElement<InviteButtonProps>}
 * @constructor
 */
export default function InviteButton(
    props: InviteButtonProps,
): React.ReactElement<InviteButtonProps> {
  const {isModalVisible, setModalVisible} = useModal();

  /**
   * Render button.
   * @return {JSX.Element}
   */
  function renderButton(): JSX.Element {
    /**
     * Button click event handler.
     */
    function handleClick(): void {
      setModalVisible(!isModalVisible);
    }

    return (
      <Button
        type="button"
        variant={ButtonVariant.Outline}
        onClick={handleClick}
      >
        Добавить студента
      </Button>
    );
  }

  /**
   * Render a modal window.
   * @return {JSX.Element | undefined}
   */
  function renderModal(): JSX.Element | undefined {
    /**
     * Modal blur event handler.
     */
    function handleBlur(): void {
      setModalVisible(false);
    }

    return isModalVisible ? (
      <InviteModal
        onBlur={handleBlur}
        onInvite={props.onInvite}
      />
    ) : undefined;
  }

  return (
    <React.Fragment>
      {renderButton()}
      {renderModal()}
    </React.Fragment>
  );
}
